export default [
    {
        path: "radius-auth-server",
        name: "radiusserver",
        component: () =>
            import(
            /* webpackChunkName: "RadiusServer" */ "../pages/radiusServer/RadiusServer.vue"
            ),
        meta: {
            title: `Radius Auth Server List`,
        },
    },
    {
        path: "add-add-radius-auth-server",
        name: "addnewradiusserver",
        component: () =>
            import(
            /* webpackChunkName: "AddRadiusServer" */ "../pages/radiusServer/AddRadiusServer.vue"
            ),
        meta: {
            title: `Add New Radius Server`,
        },
    },
    {
        path: "/edit-radius-auth-server/:id",
        name: "EditRadiusAuth",
        component: () =>
            import(
            /* webpackChunkName: "AddRadiusServer" */ "../pages/radiusServer/AddRadiusServer.vue"
            ),
        meta: {
            title: `Edit Radius Auth Server`,
        },
    },
    {
        path: "/install-auth-server/:id",
        name: "InstallAuth",
        component: () =>
            import(
            /* webpackChunkName: "InstallAuth" */ "../pages/radiusServer/InstallAuthServer.vue"
            ),
        meta: {
            title: `Install Auth Server`,
        },
    }
];
